/* eslint no-irregular-whitespace: 0 */

const SubscriptionFaq = [
  {
    title: 'General',
    content: [
      {
        question: 'How does the subscription program work?',
        response: `
          <p>Vuse’s new monthly subscription program brings you discounts and convenience for your vaping pods.</p>
          <p>Simply Subscribe to a <strong>minimum</strong> of 3 packs of ePen 3 pods or ePod pods and get up to 30% off per order and free standard shipping.</p>
        `
      }
    ]
  },
  {
    title: 'Discounts',
    content: [
      {
        question: 'What discounts can I get by signing-up to a subscription?',
        response: `
          <p>Subscription discounts are based on the quantity of products you subscribe to and vary from 20% to 30% per order. </p>
          <ul>
            <li>3-4 packs/subscription order : 20% off*</li>
            <li>5+ packs/subscription order : 25% off*</li>
          </ul>
          <p><small>*Free standard shipping is included for all orders.</small></p>
          <p>Vuse+ members also get a vaping device included upon their 1st subscription.</p>
          <p>Platinum Vuse+ members get an additional 5% discount and free express shipping.</p>
        `
      },
      {
        question: 'Is shipping included?',
        response: `Yes! Free standard shipping is included for all subscription orders. Platinum Vuse+ members get free express shipping.`
      }
    ]
  },
  {
    title: 'Subscription order',
    content: [
      {
        question: 'Can I pause my subscription?',
        response: `
          <p>Yes! You can pause your subscription for up to <strong>90 days</strong>. To do so, go to “subscriptions” within your <a href="https://vuse.com/ca/en/account/subscriptions/">account section</a>.</p>
      `
      },
      {
        question: 'Can I cancel my subscription?',
        response: `
          <p>Yes, you can cancel your subscription. Note that cancellations are not reversible and by cancelling the subscription, you will no longer be receiving your discount (20-30% off).</p>
          
        `
      },
      {
        question: 'I got an email stating items in my subscription are out of stock, what does this mean?',
        response: `
          <p>We do our best to always ensure you receive your favourite products. However, there could be times when we aren’t able to fulfill your order completely due to reasons out of our control. If this is the case, you will receive an email confirming the action we’re taking to fulfill your order.</p>
        `
      },
      {
        question: 'Can I have multiple subscriptions?',
        response: `
          <p>No, only 1 subscription order per account is allowed. You can make changes to your subscription within your <a href="https://vuse.com/ca/en/account/subscriptions/">account section</a> under (subscriptions).</p>
        `
      },
      {
        question: 'Can I edit the items in my subscription?',
        response: `
          <p>You can edit your active subscriptions at any time by heading to the subscription tab in your <a href="https://vuse.com/ca/en/account/subscriptions/">account section</a>.</p>
        `
      },
      {
        question: 'What can I subscribe to?',
        response: `
          <p>You can subscribe to any of our ePod and ePen  vaping pods.</p>
        `
      }
    ]
  },
  {
    title: 'Shipping',
    content: [
      {
        question: 'When will I get my subscription orders?',
        response: `
          <p>Upon subscribing to a new order, you can select the start date at which you want to receive your order. Future subscription orders will be delivered to you in 30 days intervals from the start date you select. You can view the next estimated delivery date at any time within your <a href="https://vuse.com/ca/en/account/subscriptions/">account section</a>.</p>
        `
      },
      {
        question: 'Can I change the delivery frequency for my order?',
        response: `
          <p>Delivery frequencies can’t be changed and are defaulted to 30 days intervals. Out of product and want to get your subscription order earlier? Head to your <a href="https://vuse.com/ca/en/account/subscriptions/">account section</a> and choose a new date for your active subscription.</p>
        `
      },
      {
        question: 'Can I choose a start date for my order?',
        response: `
          <p>Yes! Upon subscribing to a new order, you can select the start date at which you want to receive your order. You can select a date up to 30 days in the future.</p>
        `
      },
      {
        question: 'Can I track my order?',
        response: `
          <p>Yes, once your order is shipped, you will receive a shipping confirmation email containing a tracking number.</p>
        `
      },
      {
        question: 'How can I unpause my subscription?',
        response: `
          <p>You can unpause your active subscription order at anytime via the “subscriptions” tab in your <a href="https://vuse.com/ca/en/account/subscriptions/">account section</a>.</p>
        `
      },
      {
        question: 'I cancelled my subscription order, can I reactivate it?',
        response: `
          <p>Unfortunately, a cancelled subscription order cannot be reactivated. Alternatively, you can place a new subscription order.</p>
        `
      },
      {
        question: 'My subscription order is late, what should I do?',
        response: `
          <p>The date we provide is an estimate of the delivery date. Note that your order could arrive later than the estimated delivery date due to circumstances out of our control. You can track your order with the tracking code provided to you in the shipping confirmation email.</p>
          <p>If your order still did not arrive within 5 business days after the estimated delivery date, please contact us.</p>
        `
      }
    ]
  },
  {
    title: 'Payment',
    content: [
      {
        question: 'When will I be charged?',
        response: `
          <p>When you sign up for a new subscription, payment for your initial subscription delivery will be billed immediately. Following subscription orders are charged once your order is packed and ready to be shipped, approximately every 30 days starting from the date on which the first subscription is created. This is typically 2-4 business days prior to the estimated delivery date.</p>
        `
      },
      {
        question: 'Can I change the payment method?',
        response: `
          <p>Yes, you can change your payment method at any time for active subscriptions by heading to the subscription tab in your <a href="https://vuse.com/ca/en/account/subscriptions/">account section</a>.</p>
        `
      },
      {
        question: 'I got an email stating that the payment for my subscription failed, what should I do?',
        response: `
          <p>We process the payment for your subscription order 2-4 business days prior to the estimated delivery date. Should the payment fail, you will receive an email notification. Please head to the subscription tab in your <a href="https://vuse.com/ca/en/account/subscriptions/">account section</a> to make the appropriate adjustments to your payment method for the payment to be successful. Up to 3 payment attempts will be done after which your subscription will be for a maximum period of 90 days after which it will be cancelled.</p>
        `
      },
      {
        question: 'When do I know if I’ve been charged for my subscription?',
        response: `
          <p>An order confirmation email will be sent to you confirming the amount charged to your payment method once the payment is successful.</p>
        `
      }
    ]
  }
]

export default SubscriptionFaq
